import classnames from 'classnames';
import { FormattedMessage } from 'components/shared/Intl';
import type { IntlKey } from 'locales';
import { FC, ReactNode } from 'react';
import { NavItem, NavLink } from 'react-bootstrap';

interface TabHeaderProps {
  tabId: string;
  label: IntlKey;
  activeTab: string | undefined;

  className?: string;

  beforeLabel?: ReactNode;

  afterLabel?: ReactNode;
  e2eId: string;
  disabled?: boolean;
  onTabSelected(tabId: string): void;
}
export const TabHeader: FC<TabHeaderProps> = ({
  tabId,
  label,
  activeTab,
  onTabSelected,
  afterLabel,
  beforeLabel,
  e2eId,
  disabled = false,
  className,
}) => {
  return (
    <NavItem id={e2eId + '-header'} as="li">
      <NavLink
        id={tabId}
        className={classnames({ active: activeTab === tabId }, className)}
        onClick={() => onTabSelected(tabId)}
        disabled={disabled}
      >
        {beforeLabel}
        <FormattedMessage id={label} />
        {afterLabel}
      </NavLink>
    </NavItem>
  );
};

TabHeader.displayName = 'TabHeader';
